import debug from 'debug';

/**
 * Loggt über die "debug"-Bibliothek. Vorteil: Man kann einem Logger
 * einen Namen geben - hier bietet sich die Variable __filename an, die
 * in der Webpack-Config freigeschaltet ist. Auf diese Weise kann man in 
 * der Browser-Konsole nachvollziehen, von wo die Log-Ausgaben kommen. Außerdem
 * hat man hier eine Zentrale Stelle, an der man die Logger genauer steuern kann.
 * 
 * Beispiel: 
 * 
 * import Logger from "../../Logger";
 * const LOGGER = new Logger(__filename);
 * 
 * LOGGER.log(...)
 * LOGGER.info(...)
 * LOGGER.warn(...)
 * LOGGER.error(...)
 * 
 */
export default function Logger(loggerName) {

    const finalLoggerName = `[${loggerName}]`;

    const log = debug(finalLoggerName);
    log.log = console.log.bind(console); // don't forget to bind!
    log.enabled = true;

    const info = debug(finalLoggerName);
    info.log = console.info.bind(console); // don't forget to bind!
    info.enabled = true;

    const error = debug(finalLoggerName);
    error.log = console.error.bind(console); // don't forget to bind!
    error.enabled = true;

    const warn = debug(finalLoggerName);
    warn.log = console.warn.bind(console); // don't forget to bind!
    warn.enabled = true;

    return { log, info, warn, error };
}

